module.exports = __webpack_public_path__ + "img/P4-0-1.1ea3dd46.svg";